<mat-form-field [appearance]="appearance" fxFlex>
  <mat-label>{{ 'MAINTENANCES.STATUS' | translate }}</mat-label>
  <mat-select [(formControl)]="selectValue" required>
    <mat-option class="new-status" value="new">
      {{ 'MAINTENANCES.STATUS_OPTIONS.NEW' | translate }}
    </mat-option>
    <mat-option class="pending-status" value="requested">
      {{ 'MAINTENANCES.STATUS_OPTIONS.REQUESTED' | translate }}
    </mat-option>
    <mat-option class="pending-status" value="onNegotiation">
      {{ 'MAINTENANCES.STATUS_OPTIONS.ON_NEGOTIATION' | translate }}
    </mat-option>
    <mat-option class="pending-status" value="pending">
      {{ 'MAINTENANCES.STATUS_OPTIONS.PENDING' | translate }}
    </mat-option>
    <mat-option class="scheduled-status" value="scheduled">
      {{ 'MAINTENANCES.STATUS_OPTIONS.SCHEDULED' | translate }}
    </mat-option>
    <mat-option class="inProgress-status" value="inProgress">
      {{ 'MAINTENANCES.STATUS_OPTIONS.IN_PROGRESS' | translate }}
    </mat-option>
    <mat-option class="done-status" value="done">
      {{ 'MAINTENANCES.STATUS_OPTIONS.DONE' | translate }}
    </mat-option>
    <mat-option class="canceled-status" value="canceled">
      {{ 'MAINTENANCES.STATUS_OPTIONS.CANCELED' | translate }}
    </mat-option>
    <mat-option class="reported-status" value="reported">
      {{ 'MAINTENANCES.STATUS_OPTIONS.REPORTED' | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>
